import styled from 'styled-components';

export const NavigationWrapper = styled.div`
  position: absolute;
  top: 20px;
  left: 0;
  right: 0;
  z-index: 2;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const NavigationOverlay = styled.div`
  background: rgba(0, 0, 0, 0.5);
  padding: 8px 15px;
  border-radius: 4px;
  color: #fff;
  display: flex;
  align-items: center;
  gap: 15px;
`;

export const NavigationButton = styled.button`
  background: none;
  border: none;
  color: #fff;
  cursor: pointer;
  padding: 0;
  display: flex;
  align-items: center;
  opacity: 0.8;
  transition: opacity 0.2s ease;

  &:hover {
    opacity: 1;
  }

  &:focus {
    outline: none;
  }
`;

export const Counter = styled.span`
  color: #fff;
  font-size: 14px;
  font-weight: 500;
`;
